import { Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { ArbitrationsState } from './arbitrations.model';
import { ArbitrationsStore } from './arbitrations.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'date',
  sortByOrder: Order.DESC
})
export class ArbitrationsQuery extends QueryEntity<ArbitrationsState> {
  constructor(protected arbitrationsStore: ArbitrationsStore) {
    super(arbitrationsStore);
  }
}
